import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AUTH_LOGIN_ROUTE } from './auth-login-route.token';
import { AuthService } from './auth.service';

/**
 * Guards the company surface: a signed-out visitor hitting a deep link lands on the login route
 * with `?returnUrl=` so the auth screen can bring them back to where they were heading.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const loginRoute = inject(AUTH_LOGIN_ROUTE);
  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(loginRoute, { queryParams: { returnUrl: state.url } });
};